export enum SignupEnum {
  SUPPLIER = "SUPPLIER",
  FREELANCE = "FREELANCE"
}
